import { Badge } from "@mantine/core";

function getBadgeDetails(props: any) {
  const colorProps = props.value1.props.find(
    (prop: any) => prop.name.toLowerCase() === "__color"
  );
  return {
    value: props.value1.label || props.value1.value,
    color: colorProps ? colorProps.value : "gray",
  };
}

export default function DBadge({
  data,
  component,
}: {
  data: any;
  component?: string;
}) {
  const badgeDetails = getBadgeDetails(data);

  return (
    <Badge size="sm" radius="xs" color={badgeDetails.color} variant="light">
      {badgeDetails.value}
    </Badge>
  );
}
